import { Tween } from '../../../vendor_core/core/src/Tween';
import PromiseHelpers from '../../../vendor_core/core/src/utils/PromiseHelpers';
import WinSymbolsView from "../../../vendor_core/core/src/views/WinSymbolsView";

export default class TRWWinSymbolsView extends WinSymbolsView {
    public playAnimaAtReelCell(reel: number, row: number, id: number, anim?: string): Promise<boolean> {
        this.scene.containers.get("wins").enableMask();
        let symAnim = this.getAnimAtReelCell(reel, row);
        symAnim.setVisible(true);
        Tween.delayedCall(0.5, () => super.playAnimaAtReelCell(reel, row, id, "coin_tranform", 1.5))
        return super.playAnimaAtReelCell(reel, row, id, "win", 1.5)
    }
}
